<section class="container-fluid">
  <aside class="card">
    <div class="row">
      <div class="col-12 padding-margin-zero">
        <div class="header-card card-body">
          <div class="center-div">
            <div>
              The requested {{ activityType }} does not exist.<br />Please click 'Go Home' to
              continue or contact NYCHA for further assistance.
            </div>
          </div>
        </div>
        <footer class="card-footer d-grid">
          <div class="bottom-link">
            <span
              ><a href="/contact" class="btn">Contact NYCHA</a
              ><a href="/" class="btn gap">Go Home</a></span
            >
          </div>
        </footer>
      </div>
    </div>
  </aside>
</section>
